import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private http: HttpClient) { }
  makeRandom(lengthOfCode: number, possible: string) {
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  buildDataTableColumns(exportTitle: string, exportColumns: number[]) {
    return [
      {
        extend: 'copyHtml5',
        className: 'btn btn-outline-danger mb-1',
        exportOptions: {
          columns: exportColumns
        },
        title: exportTitle
      },
      {
        extend: 'excelHtml5',
        className: 'btn btn-outline-danger mb-1',
        exportOptions: {
          columns: exportColumns
        },
        title: exportTitle
      },
      {
        extend: 'csvHtml5',
        className: 'btn btn-outline-danger mb-1',
        exportOptions: {
          columns: exportColumns
        },
        title: exportTitle
      },
      {
        extend: 'pdfHtml5',
        className: 'btn btn-outline-danger mb-1',
        exportOptions: {
          columns: exportColumns
        },
        title: exportTitle
      },
      {
        extend: 'print',
        className: 'btn btn-outline-danger mb-1 mr-1',
        exportOptions: {
          columns: exportColumns
        },
        title: exportTitle
      }
    ];
  }
  // Error handling
  errorHandl(error: any) {
    console.log(error);
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
